import '../App.css';
import { useState } from "react";

function PlayerRankings({ players, games, seasons }) {
    const [playerPage, setPlayerPage] = useState(1);
    const playersPerPage = 10;


    const totalPlayerPages = Math.ceil(players.length / playersPerPage);
    const playerStartIndex = (playerPage - 1) * playersPerPage;
    const paginatedPlayers = players.slice(
        playerStartIndex,
        playerStartIndex + playersPerPage
    );


    



    return <>
        <div className="rankings-box">
            {paginatedPlayers.map((player, index) => {


            const filteredGames = games.filter((game) => {
                const id = parseInt(player.id);

                return (
                game.player1_id === id ||
                game.player2_id === id
                );
            });

            let winStreak = 0;

            for (let i = 0; i < filteredGames.length; i++) {
                const game = filteredGames[i];
                const isWin = game.winner_id === player.name;
                if (isWin) {
                    winStreak++;
                } else {
                    break;
                }
            }

            const overallIndex = playerStartIndex + index; // to show the correct rank number
            return (
                <div className="player-card" key={player.id}>
                    <div className="player-header">
                        <span className={`player-rank rank-${overallIndex + 1}`}>
                        {overallIndex + 1}
                        </span>
                        <strong className="player-name">{player.name}{player.name === seasons[seasons.length - 1]?.first && " 🏅"} {winStreak > 1 && <img src={`${process.env.PUBLIC_URL}/8Ball.png`} alt="8 Ball" style={{ width: '30px', height: '30px' }}/>}{winStreak > 1 && `x${winStreak}`}</strong>
                    </div>
                    <div className="player-stats">
                        <span>Rating: <span style={{fontWeight: 'bold', fontSize: 'large'}}>{player.rating}</span></span>
                        <span>Wins: {player.wins}</span>
                        <span>Losses: {player.losses}</span>
                        <span>Games: {player.games_played}</span>
                    </div>
                    {player.season_wins > 0 && (
                        <div className="season-star">
                            ⭐
                            {player.season_wins > 1 && ` x${player.season_wins}`}
                        </div>
                    )}
                </div>
            );
            })}
        </div>

        <div className="pagination">
            <button
            disabled={playerPage === 1}
            onClick={() => setPlayerPage(playerPage - 1)}
            >
            Prev
            </button>

            <span style={{ margin: "0 10px" }}>
            Page {playerPage} of {totalPlayerPages}
            </span>

            <button
            disabled={playerPage === totalPlayerPages}
            onClick={() => setPlayerPage(playerPage + 1)}
            >
            Next
            </button>
        </div>
    </>
}

export default PlayerRankings;